module.exports = __webpack_public_path__ + "static/img/newsBanner.8442fcc5.png";